<template>
  <div class="mystudio container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4
                  class="card-title"
                  :class="{
                    ' card-title-astrology': client_name == 'AV',
                    ' card-title-irish-date': client_name == 'MID',
                  }"
                >
                  Questionnaire {{ client_name }}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-overlay
            class="overlay-show-center"
            :show="overlay_show"
            rounded="sm"
            :variant="client_name == 'AV' ? 'astrology-primary' : 'mid-primary'"
            opacity="0.5"
            blur="2px"
          >
            <dataset
              v-slot="{ ds }"
              :ds-data="questions"
              :ds-filter-fields="{
                question: startsWithFilter,
              }"
              :ds-search-in="['question']"
              :ds-search-as="{}"
              rdsPage="2"
            >
              <div
                class="row mb-2"
                :data-page-count="ds.dsPagecount"
                dsShowEntries="1"
              >
                <div class="col-md-8">
                  <b-input-group
                    class=""
                    :class="{
                      'input-group-search-astrology': client_name == 'AV',
                      'input-group-search-mid': client_name == 'MID',
                    }"
                  >
                    <template #prepend>
                      <font-awesome-icon
                        icon="fa-solid fa-magnifying-glass"
                        size="lg"
                      />
                    </template>
                    <dataset-search
                      ds-search-placeholder="Search"
                      class=""
                      :class="{
                        'form-control-astrology': client_name == 'AV',
                        'form-control-mid': client_name == 'MID',
                      }"
                  /></b-input-group>
                </div>
                <div class="col-md-2 addButtonContainerDiv">
                  <b-button
                    variant="btn-bumblebee"
                    class="btn btn-filter m-0"
                    :class="{
                      'btn-astrology btn-astrology-primary':
                        client_name == 'AV',
                      'btn-mid btn-mid-primary': client_name == 'MID',
                    }"
                    @click="clickAddQuestion"
                  >
                    + Add new question
                  </b-button>
                </div>
              </div>
              <dataset-show class="d-none" :ds-show-entries="1" />
              <!-- end row of search and add event link-->

              <div class="row">
                <div class="col-md-12">
                  <dataset-item class="row mb-3">
                    <template #default="{ row, rowIndex }">
                      <SingleQuestion
                        is_describe_yourself="false"
                        :question="row"
                        :index="rowIndex"
                        :client_name="client_name"
                        :question_types="question_types"
                      />
                    </template>
                    <template #noDataFound>
                      <div class="col-md-12 pt-2">
                        <p
                          class="text-center datasetNoFoundP"
                          :class="{
                            noDataFoundAV: client_name == 'AV',
                            noDataFoundMID: client_name == 'MID',
                          }"
                        >
                          No questions found
                        </p>
                      </div>
                    </template>
                  </dataset-item>
                </div>
              </div>
              <div
                class="
                  d-flex
                  flex-md-row flex-column
                  justify-content-between
                  align-items-center
                "
              >
                <dataset-info
                  class="mb-2 datasetInfo"
                  :class="{
                    datasetInfoAV: client_name == 'AV',
                    datasetInfoMID: client_name == 'MID',
                  }"
                />
                <dataset-pager
                  class=""
                  ref="questionsPager"
                  :class="{
                    datasetPagerAV: client_name == 'AV',
                    datasetPagerMID: client_name == 'MID',
                  }"
                />
                <!-- <Pager ref="questionsPager" /> -->
              </div>
            </dataset>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SingleQuestion from "./SingleQuestion.vue";

import axios from "axios";
import $ from "jquery";

import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce } from "vue-dataset/src/helpers";

export default {
  //name: "MIDQuestionnaires",
  name: "ListQuestions",
  components: { SingleQuestion },
  props: ["client_name", "question_types"],
  data() {
    return {
      overlay_show: false,
      questions: [],

      onlineFilter: "",
      selected: 2,
      startsWith: "",
      eventAsc: true,
      event_id: null,
      datasetI18n: {
        show: "Show",
        entries: "entries",
        previous: "<",
        next: ">",
        showing: "Showing",
        showingTo: "to",
        showingOf: "of",
        showingEntries: "entries",
      },
    };
  },
  computed: {
    // dsPage () {
    //   return this.rdsPage()
    // }
  },
  watch() {},
  mounted() {
    this.getQuestionsList();
    // this.setActive(2)
    // console.log(Pager.setActive(2))
    // console.log(this.$refs.questionsPager);
    // this.$refs.questionsPager.setActive(3);
  },
  created() {
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
    // this.setActive(2)
  },
  methods: {
    getQuestionsList() {
      this.overlay_show = true;
      axios
        .get("social/admin/questions", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.data);
          this.questions = response.data.data;

          if (this.client_name == "AV") {
            for (let i = 0; i < this.questions.length; i++) {
              if (this.questions[i].type == "audio") {
                for (let j = 0; j < this.questions[i].options.length; j++) {
                  this.questions[i].options[j].audio = {
                    path:
                      "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-" +
                      (j + 1) +
                      ".mp3",
                    id: j+1  
                  };
                }
              }
            }
          }
          console.log(this.questions)

          this.overlay_show = false;
          // this.interests = response.data.data;
        })
        .catch((error) => {
          // console.log(error.response);
          // this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.getQuestionsList();
        });
    },
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    updateData() {
      const updatedEvents = clone(events).slice(1, 1);
      this.events = updatedEvents;
    },
    startsWithFilter(value) {
      return value.toLowerCase().startsWith(this.startsWith.toLowerCase());
    },
    clickAddQuestion() {
      this.questions.push({
        id: null,
        question: "",
        options: [],
        new_question: true,
      });
      console.log(this.$refs.questionsPager.dsPagecount, new Date());
      let temp = this;
      setTimeout(function () {
        console.log(temp.$refs.questionsPager.dsPagecount, new Date());
        console.log(temp);
        console.log(temp.$refs);
        temp.$refs.questionsPager.setActive(
          temp.$refs.questionsPager.dsPagecount
        );
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/ListQuestions.vue